import Logo from '../../src/asset/images/logo.svg'

const ChildSafety = () => {
    return (
        <>
            <header className="sticky-top">
                <nav className="navbar navbar-expand-lg py-2">
                    <div className="container">
                        <a className="navbar-brand" href="/"><img src={Logo} alt="img" /></a>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                    </div>
                </nav>
            </header>
            <section class="py-4">
                <div class="container" style={{maxWidth: '950px'}}>
                    <h1 class="fw-bold text-decoration-underline text-center mb-4">
                        Our Commitment to Safety: Preventing CSAE
                    </h1>

                    <p>
                        At <strong>Shadowz</strong>, the safety and well-being of our users, especially minors, are our top priority.
                        We are dedicated to creating a safe, respectful, and positive environment where everyone can connect and
                        interact securely. To ensure this, we adhere to stringent measures to protect against Child Sexual Abuse and
                        Exploitation (CSAE). Below, you’ll find information on how we work to prevent abuse, our reporting process,
                        and the resources available to help keep the community safe.
                    </p>

                    <h5 class="mt-4 fw-semibold">1. Clear Standards of Conduct</h5>

                    <p>We expect all users to respect one another and behave responsibly on our platform. We have developed and implemented strict standards of conduct to prevent any form of sexual abuse or exploitation, including:</p>

                    <ul>
                        <li>Zero tolerance for abusive or exploitative behavior, including attempts to engage minors or inappropriate messaging.</li>
                        <li>Clear prohibited content guidelines, including explicit content, grooming, and predatory behavior.</li>
                        <li>Age verification processes to ensure that only users of appropriate age can access the platform.</li>
                    </ul>

                    <h5 class="mt-4 fw-semibold">2. Age Verification and Monitoring</h5>

                    <p>To prevent minors from using our app, we use a combination of age verification techniques, including:</p>

                    <ul>
                        <li>Registration and account checks that require users to confirm their age during sign-up.</li>
                        <li>Continuous monitoring of user interactions for signs of harmful or inappropriate activity.</li>
                        <li>Active content moderation to flag and remove suspicious profiles or interactions.</li>
                    </ul>

                    <h5 class="mt-4 fw-semibold">3. Reporting and Support for Victims</h5>

                    <p>If you encounter content or behavior that violates our safety standards, including CSAE-related issues, we urge you to report it immediately. Our team is committed to investigating all reports swiftly and confidentially. Here’s how to report:</p>

                    <ul>
                        <li><strong>In-App Reporting:</strong> You can report abusive or inappropriate behavior directly from user profiles or conversations by clicking the “Report” button.</li>
                        <li><strong>Emergency Help:</strong> If you or someone you know is at immediate risk, we encourage you to contact local law enforcement or a trusted professional.</li>
                        <li>We also partner with leading child protection organizations and online safety initiatives to offer support to victims and ensure that reports are handled responsibly.</li>
                    </ul>

                    <h5 class="mt-4 fw-semibold">4. Educational Resources</h5>

                    <p>We believe in proactive education. We provide resources to help our users better understand online safety and how to protect themselves and others from potential harm. These include:</p>

                    <ul>
                        <li>Safety tips for users, especially when meeting people online.</li>
                        <li>Guidance on recognizing warning signs of grooming or exploitation.</li>
                        <li>Access to online safety courses for both new and existing users.</li>
                    </ul>

                    <h5 class="mt-4 fw-semibold">5. What We Do to Prevent CSAE</h5>

                    <p>Our team works diligently behind the scenes to ensure the integrity of the platform:</p>

                    <ul>
                        <li>We employ advanced content filtering and AI-based monitoring systems to detect and block any potential CSAE-related content before it reaches users.</li>
                        <li>Regular audits and updates to our safety features and policies to ensure we stay ahead of emerging threats.</li>
                        <li>Collaborations with child protection authorities, cybersecurity experts, and nonprofit organizations focused on CSAE prevention.</li>
                    </ul>

                    <h5 class="mt-4 fw-semibold">6. Legal Compliance</h5>

                    <p><strong>Shadowz</strong> complies with all applicable laws and regulations, including:</p>

                    <ul>
                        <li>COPPA (Children’s Online Privacy Protection Act) in the U.S., ensuring that users under 13 cannot create accounts or access the platform.</li>
                        <li>GDPR (General Data Protection Regulation) for users in the EU, with a particular focus on safeguarding the personal data of minors.</li>
                        <li>Local laws and international frameworks that protect against child exploitation and abuse.</li>
                    </ul>
                </div>
            </section>


        </>
    )
}


export default ChildSafety;
